import { render, staticRenderFns } from "./ApprovalRemoteRequestDetail.vue?vue&type=template&id=4c0176ea&scoped=true&"
import script from "./ApprovalRemoteRequestDetail.vue?vue&type=script&lang=js&"
export * from "./ApprovalRemoteRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalRemoteRequestDetail.vue?vue&type=style&index=0&id=4c0176ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0176ea",
  null
  
)

export default component.exports